import { Folder } from '@model/folder';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { map, catchError } from "rxjs/operators";
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@theme/utils/api.service';
import { NoInternetHelper } from '@theme/utils/no-internet-helper';

@Injectable({
  providedIn: 'root'
})
export class FolderService {
  folder: Folder;
  public edit: boolean = false;
  public validated: boolean = false;
  private urlBase = environment.publicUrl;
  private namespace = "agency/folder/customer";
  private url = "private/agency/folder/customer";

  constructor(
    private api: ApiService,
    public httpClient: HttpClient
  ) { }

  setFolder(folder: Folder) {
    this.folder = folder
  }
  getFolder(): Folder {
    return this.folder
  }
  add(data: Folder): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    if (data.uuid) {
      return this.update(data);
    } else {
      return this.create(data);
    }
  }
  create(data: Folder): Observable<any> {
    return this.api._post(`${this.url}/new`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  simulerApportSupplementaire(data: Folder): Observable<any> {
    return this.api._post(`${this.url}/apport/simulate`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  ajouterApportSupplementaire(data: Folder): Observable<any> {
    return this.api._post(`${this.url}/apport/add`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  update(data: Folder): Observable<any> {
    return this.api._post(`${this.url}/${data.uuid}/edit`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  activate(data: Folder): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._post(`${this.url}/${data.uuid}/activate`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  annulerApportSupplementaire(data: any): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._post(`${this.url}/${data.uuid}/activate`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  deactivate(data: Folder): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._post(`${this.url}/${data.uuid}/deactivate`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  getList(customerUuid?: string, etat?: string, ownerUuid?: string, count?: number): Observable<Folder[]> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._get(`${this.url}/`, {
      customerUuid: customerUuid,
      etat: etat,
      ownerUuid: ownerUuid,
      count: count
    }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  getApportsSupplementaires(folderUuid?: string, etat?: string, ownerUuid?: string): Observable<Folder[]> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._get(`${this.url}/apports`, {
      folderUuid: folderUuid,
      etat: etat,
      ownerUuid: ownerUuid
    }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }
  getSingle(uuid: string): Observable<Folder> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._get(`${this.url}/show`, { uuid: uuid }).pipe(
      map((response: any) => response.data),
      catchError((error: any) => throwError(error))
    );
  }
  getPrinter(type: string, agencyKey: string, userKey: string, data: any): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    let url = 'printer/' + this.namespace + '/' + agencyKey + '/' + userKey;
    if (type === 'LISTE') {
      if (data && data !== undefined) {
        for (const k in data) {
          if (data.hasOwnProperty(k)) {
            if (k !== 'uuid') {
              url += '/' + (data[k] !== undefined && data[k] !== '' ? data[k] : null);
            }
          }
        }
      } else {
        url += '/DOSSIER/null/null/null/null/null/null/null/null/null/DESC/null/null/null/null/10/null'
      }
    }
    if (type === 'SHOW') {
      url = (data) ? url + '/' + data : url;
    }
    if (type === 'CERTIFICATE') {
      url = (data) ? url + '/' + data + '/certificate' : url;
    }
    if (type === 'CONTRAT') {
      url = (data) ? url + '/' + data + '/contrats' : url;
    }
    if (type === 'ENGAGEMENT') {
      url = (data) ? url + '/' + data + '/engagements' : url;
    }
    if (type === 'REGLEMENT') {
      url = (data) ? url + '/' + data + '/reglements' : url;
    }
    window.open(`${this.urlBase}/${url}`, '_blank');
  }

  // getPrinterContract(agencyKey: string, userKey: string, uuid: string): void {
  //   if (!navigator.onLine) {
  //       NoInternetHelper.internet();
  //       return Observable.create(obs => {
  //           obs.next();
  //           obs.complete();
  //       });
  //   }

  //   // Appeler l'API Symfony pour récupérer les URLs des templates
  //   const url = `${this.urlBase}/printer/${this.namespace}/${agencyKey}/${userKey}/${uuid}/fusions`;

  //   this.httpClient.get<{ engagementUrl: string, contratUrl: string, reglementUrl: string, inventoryUrl: string }>(url).subscribe({
  //       next: (response) => {
  //         console.log(response)
  //           const urls = [
  //               response.reglementUrl,
  //               response.inventoryUrl,
  //               response.engagementUrl,
  //               response.contratUrl
  //           ];

  //         console.log(urls)
  //           // Ouvrir chaque URL dans un nouvel onglet
  //           urls.forEach((url, index) => {
  //               if (url) {
  //                   // Si vous voulez ajouter un titre spécifique à chaque onglet
  //                   const title = `Impression ${index + 1}`;
  //                   const newWindow = window.open(`${this.urlBase}${url}`, '_blank');
  //                   if (newWindow) {
  //                       newWindow.document.title = title;  // Définir un titre pour chaque onglet
  //                   }
  //               }
  //           });
  //       },
  //       error: (err) => {
  //           console.error('Erreur lors de la récupération des URLs :', err);
  //       }
  //   });
  // }

  // getPrinterContract(agencyKey: string, userKey: string, uuid: string): void {
  //   if (!navigator.onLine) {
  //       NoInternetHelper.internet();
  //       return Observable.create(obs => {
  //           obs.next();
  //           obs.complete();
  //       });
  //   }
  //   const documents = [
  //       { name: 'CONTRAT', url: 'printer/' + this.namespace + '/' + agencyKey + '/' + userKey+ '/' + uuid + '/contrats' },
  //       { name: 'ETAT DES LIEUX D’ENTRÉE ET DE SORTIE ',url: 'printer/' + this.namespace + '/' + agencyKey + '/' + userKey+ '/' + uuid + '/inventorys' },
  //       { name: 'REGLEMENT DE COPROPRIETE', url: 'printer/' + this.namespace + '/' + agencyKey + '/' + userKey+ '/' + uuid + '/reglements' },
  //       { name: 'ENGAGEMENT DU PROPRIETAIRE/LOCATAIRE ACCEDANT',url: 'printer/' + this.namespace + '/' + agencyKey + '/' + userKey+ '/' + uuid + '/engagements' }
  //   ].filter(doc => doc.url);

  //   // Créer un div pour contenir les liens
  //   const container = document.createElement('div');
  //   container.style.padding = '10px';
  //   container.style.position = 'fixed';
  //   container.style.top = '50%';
  //   container.style.left = '50%';
  //   container.style.transform = 'translate(-50%, -50%)';
  //   container.style.background = 'white';
  //   container.style.border = '1px solid black';
  //   container.style.zIndex = '1000';

  //   // Ajouter un titre
  //   const title = document.createElement('h3');
  //   title.textContent = '';
  //   container.appendChild(title);

  //   // Créer un lien pour chaque document
  //   documents.forEach(doc => {
  //       // const link = document.createElement('a');
  //       // link.href = `${this.urlBase}${doc.url}`;
  //       // link.target = '_blank';
  //       // link.textContent = `Ouvrir ${doc.name}`;
  //       // link.style.display = 'block';
  //       // link.style.margin = '5px';
  //       // container.appendChild(link);
  //       window.open(`${this.urlBase}/${doc.url}`, '_blank');
  //   });

  //   // Ajouter un bouton pour fermer
  //   const closeButton = document.createElement('button');
  //   closeButton.textContent = 'Fermer';
  //   closeButton.onclick = () => container.remove();
  //   container.appendChild(closeButton);

  //   // Ajouter le conteneur à la page
  //   document.body.appendChild(container);
  // }
  getPrinterContract(agencyKey: string, userKey: string, uuid: string): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return;
    }

    const documents = [
      { name: 'CONTRAT', url: `/printer/${this.namespace}/${agencyKey}/${userKey}/${uuid}/contrats` },
      { name: 'ETAT DES LIEUX D’ENTRÉE ET DE SORTIE', url: `/printer/${this.namespace}/${agencyKey}/${userKey}/${uuid}/inventorys` },
      { name: 'REGLEMENT DE COPROPRIETE', url: `/printer/${this.namespace}/${agencyKey}/${userKey}/${uuid}/reglements` },
      { name: 'ENGAGEMENT DU PROPRIETAIRE/LOCATAIRE ACCEDANT', url: `/printer/${this.namespace}/${agencyKey}/${userKey}/${uuid}/engagements` }
    ];

    // Supprimer un modal existant s'il y en a déjà un
    const existingModal = document.getElementById('customModal');
    if (existingModal) existingModal.remove();

    // Créer un div pour le modal
    const modal = document.createElement('div');
    modal.id = 'customModal';
    Object.assign(modal.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'white',
      border: '1px solid black',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)',
      zIndex: '1000',
      width: '450px',
      padding: '15px',
      textAlign: 'center',
      borderRadius: '8px'
    });

    // Ajouter un titre
    const title = document.createElement('h3');
    title.textContent = 'Les documents du dossier de vente';
    modal.appendChild(title);

    // Ajouter la liste des documents
    const list = document.createElement('ul');
    list.style.listStyleType = 'none';
    list.style.padding = '0';

    documents.forEach(doc => {
      const listItem = document.createElement('li');
      listItem.style.marginBottom = '8px';

      const button = document.createElement('button');
      button.textContent = doc.name;
      Object.assign(button.style, {
        display: 'block',
        width: '100%',
        padding: '8px',
        background: '#007BFF',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        textAlign: 'center'
      });

      button.onclick = () => {
        window.open(`${this.urlBase}${doc.url}`, '_blank', 'noopener,noreferrer');
      };

      listItem.appendChild(button);
      list.appendChild(listItem);
    });

    modal.appendChild(list);

    // Ajouter un bouton pour fermer
    const closeButton = document.createElement('button');
    closeButton.textContent = 'Fermer';
    Object.assign(closeButton.style, {
      padding: '8px 12px',
      marginTop: '10px',
      cursor: 'pointer',
      background: '#dc3545',
      color: 'white',
      border: 'none',
      borderRadius: '5px'
    });
    closeButton.onclick = () => modal.remove();
    modal.appendChild(closeButton);

    // Ajouter le modal à la page
    document.body.appendChild(modal);
  }
  getReport(agencyKey: string, userKey: string, data: any): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }
    var type = '';
    var base = 'report/agency/customer/';
    if (data?.type === 'COMPTE') {
      type = 'compte';
    } else if (data?.type === 'DOSSIER') {
      type = 'dossier';
    } else if (data?.type === 'PAIEMENT') {
      type = 'paiement';
    } else if (data?.type === 'ENCAISSEMENT') {
      type = 'encaissement';
      base = 'report/agency/promotion/';
    }

    let url = base + type + '/' + agencyKey + '/' + userKey;
    if (data && data !== undefined) {
      for (const k in data) {
        if (data.hasOwnProperty(k)) {
          if (k !== 'uuid') {
            url += '/' + (data[k] !== undefined && data[k] !== '' ? data[k] : null);
          }
        }
      }
    }
    window.open(`${this.urlBase}/${url}`, '_blank');
  }

  getExport(agencyKey: string, userKey: string, data: any): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return;
    }

    let url = 'export/folder/customer/' + agencyKey + '/' + userKey;
    if (data && data !== undefined) {
      for (const k in data) {
        if (data.hasOwnProperty(k)) {
          if (k !== 'uuid') {
            url += '/' + data[k];
          }
        }
      }
    } else {
      url += '/DOSSIER/null/null/null/null/null/null/null/null/null/DESC/null/null/null/null/10/null';
    }
    window.open(`${this.urlBase}/${url}`);
  }

  getDelete(uuid: string): Observable<Folder> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._post(`${this.url}/${uuid}/delete`, null).pipe(
      map((response: any) => response.data),
      catchError((error: any) => throwError(error))
    );
  }

  getListEcheance(customerUuid?: string, folderUuid?: string): Observable<Folder[]> {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._get(`${this.url}/echeance`, {
      customerUuid: customerUuid,
      folderUuid: folderUuid
    }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  generateChargesComptant(data: any): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => {
        obs.next();
        obs.complete();
      });
    }

    return this.api._post(`${this.url}/charges-comptant/generate`, data).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  getPrinterEcheancier(agencyKey: string, userKey: string, uuid: string, filtre: string = 'VIGUEUR'): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return;
    }
    const url = `printer/${this.namespace}/${agencyKey}/${userKey}/${uuid}/echeancier/${filtre}`;
    window.open(`${this.urlBase}/${url}`, '_blank');
  }

  getPrinterEcheance(type: string, agencyKey: string, userKey: string, data: any): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet()
      return;
    }

    let url = 'printer/' + this.namespace + '/' + agencyKey + '/' + userKey + '/echeance';
    if (type === 'LISTE') {
      if (data && data !== undefined) {
        for (const k in data) {
          if (data.hasOwnProperty(k)) {
            if (k !== 'uuid') {
              url += '/' + (data[k] !== undefined && data[k] !== '' ? data[k] : null);
            }
          }
        }
      } else {
        url += '/CLIENT/null/null/null/null/null/null/null/null/null/DESC/null/null/null/null/10/null'
      }
    }
    if (type === 'SHOW') {
      url = (data) ? url + '/' + data : url;
    }
    console.log(url)
    window.open(`${this.urlBase}/${url}`, '_blank');
  }

  /**
 * Export du tableau d'amortissement d'un dossier
 * @param agencyKey Clé de l'agence
 * @param userKey Clé de l'utilisateur
 * @param folderKey Clé du dossier
 */
  getExportAmortissement(agencyKey: string, userKey: string, folderKey: string): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return;
    }

    const url = `export/amortissement/${agencyKey}/${userKey}/${folderKey}`;
    const link = document.createElement('a');
    link.href = `${this.urlBase}/${url}`;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  convertirEnProgressif(folderUuid: string, tauxProgression: number = 0.10, intervalleProgression: number = 60): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._post(`${this.url}/${folderUuid}/convert-progressif`, {
      tauxProgression,
      intervalleProgression
    }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  convertirEnAnnuel(folderUuid: string, nbrAnnees: number, taux: number): Observable<any> {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return Observable.create(obs => { obs.next(); obs.complete(); });
    }
    return this.api._post(`${this.url}/${folderUuid}/convert-annuel`, {
      nbrAnnees,
      taux
    }).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError(error))
    );
  }

  getPrinterAmortissement(agencyKey: string, userKey: string, uuid: string): void {
    if (!navigator.onLine) {
      NoInternetHelper.internet();
      return;
    }
    const url = `printer/${this.namespace}/${agencyKey}/${userKey}/${uuid}/amortissement`;
    window.open(`${this.urlBase}/${url}`, '_blank');
  }
}

